import { useState, useEffect } from "react";

import {
  Button,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";

//Unform e componentes
import ModalViewArquivo from "@/frontend/componentes/ModalViewArquivo";

//Context
import { useAuth } from "@/frontend/context/auth";

//Common
import { fn_formatarCnpjCpf } from "@/common/utils/util";
import {
  ID_AUTORIZACAO,
  SITUACAO_PAGAMENTO,
  TIPO_ANEXO_PAGAMENTO,
} from "@/common/constantes";
import {
  fn_getLabelCampoContaBancaria,
  fn_getLabelCampoInfPagamento,
  fn_getTipoIntegracao,
} from "@/common/siig";
import { fn_formatarDataHora } from "@/common/utils/date";

//Util
import { ICONES_BOTAO, ICONES_SIIG } from "@/frontend/utils/icones";
import { fn_getPastaUploadSolicitacao } from "@/frontend/utils/file";
import { fn_getPathTenant } from "@/frontend/utils/sessao";

//API
import { api_getUltimoLogAutorizacao } from "@/frontend/services/api/api_others";
import {
  api_listar,
  api_listarHistoricoPosse,
  ROTA_LISTAR,
} from "@/frontend/services/api/api_list";
import { api_loadOpcoes, ROTA_LOAD } from "@/frontend/services/api/api_load";

//Telas
import CardLogAutorizacao from "../../../../acesso/autorizacao/card_log_autorizacao";
import TPag_historico_posse from "./pag_historico_posse";

/*
 * Apresenta a consulta da posse do documento do pagamento
 */
function TPag_det_posse({ modalOpen, toggleModal, solicitacao, pagamento }) {
  const { sessaoUsuario } = useAuth();

  //### USE STATE ###
  const [modalOpenArquivo, setModalOpenArquivo] = useState(false);
  const [modalOpenHistoricoPosse, setModalOpenHistoricoPosse] = useState(false);

  const [tipoDocumento, setTipoDocumento] = useState([]);

  const [nomeArquivoView, setNomeArquivoView] = useState(null);
  const [nomeAnexoDoc, setNomeAnexoDoc] = useState(null);
  const [nomeAnexoFormaPag, setNomeAnexoFormaPag] = useState(null);

  const [logCancelamento, setLogCancelamento] = useState(null);
  const [logsPosse, setLogsPosse] = useState([]); //cada vez que a posse foi salva (botão do histórico só com registro)

  //### USE EFFECT ###
  //Inicialização da tela
  useEffect(() => {
    //Carrega a opção tipo documento do pagamento (PROVISORIO ENQUANTO NAO TEM RELACIONAMENTO COM A TABELA SOLICITACAO_PAG)
    async function loadTipoDocumento() {
      const opcoes = await api_loadOpcoes(
        ROTA_LOAD.TIPO_DOCUMENTO,
        "situacao=A",
        { campoValue: "sigla" }, //provisorio até terminar toda a migração para tabela
      );

      setTipoDocumento(
        opcoes.find((tp) => tp.value == pagamento.tipo_documento_novo.sigla), //provisorio novo
      );
    }

    //Lista os anexos do pagamento
    async function listarAnexosPag() {
      const anexosPag = await api_listar(
        ROTA_LISTAR.SOLICITACAO_PAG_ANEXO,
        `id_solicitacao_pag=${pagamento.id}`,
      );

      const anexoDocFind = anexosPag.find(
        (anexo) => anexo.tipo_anexo == TIPO_ANEXO_PAGAMENTO.DOCUMENTO,
      );
      if (anexoDocFind) {
        setNomeAnexoDoc(anexoDocFind.nome_arquivo);
      }

      const anexoFormaPagFind = anexosPag.find(
        (anexo) => anexo.tipo_anexo == TIPO_ANEXO_PAGAMENTO.FORMA_PAGAMENTO,
      );

      if (anexoFormaPagFind) {
        setNomeAnexoFormaPag(anexoFormaPagFind.nome_arquivo);
      }
    }

    if (pagamento.situacao == SITUACAO_PAGAMENTO.CANCELADO) {
      //Carrega os dados do log de autorização do cancelamento
      async function loadLogCancelamento() {
        const log = await api_getUltimoLogAutorizacao(
          ID_AUTORIZACAO.CANCELAMENTO_PAGAMENTO,
          "SolicitacaoPag",
          pagamento.id,
        );
        setLogCancelamento(log);
      }

      loadLogCancelamento();
    }

    //Carrega o histórico da posse (cada vez que a posse foi salva)
    async function loadHistoricoPosse() {
      const logs = await api_listarHistoricoPosse(pagamento.id);
      setLogsPosse(logs || []);
    }

    loadTipoDocumento();
    listarAnexosPag();
    loadHistoricoPosse();
  }, []);

  //### EVENTOS ###
  //OnClick - Botão Visualizar documento
  function handleBotaoDocumento(nomeArquivo) {
    setNomeArquivoView(nomeArquivo);
    setModalOpenArquivo(true);
  }

  return (
    <Modal isOpen={modalOpen} backdrop="static" size="lg" scrollable>
      <ModalHeader toggle={toggleModal} className="titulo-tela-modal">
        Posse documento
      </ModalHeader>

      <ModalBody>
        <div className="m-2">
          <Row>
            <Col sm="3" md="3" lg="3">
              <Label className="fw-bold">Empresa:</Label>
            </Col>
            <Col>
              {fn_formatarCnpjCpf(solicitacao.empresa.cnpj)} -{" "}
              {solicitacao.empresa.nome}
            </Col>
          </Row>

          <Row>
            <Col sm="3" md="3" lg="3">
              <Label className="fw-bold">Fornecedor:</Label>
            </Col>
            <Col>
              {fn_formatarCnpjCpf(solicitacao.fornecedor.cnpj_cpf)} -{" "}
              {solicitacao.fornecedor.nome}
            </Col>
          </Row>

          <Row className="mt-2">
            <Col sm="3" md="3" lg="3">
              <Label className="fw-bold">Tipo documento:</Label>
            </Col>
            <Col> {tipoDocumento?.label}</Col>
          </Row>

          {pagamento.data_posse && (
            <Row>
              <Col sm="3" md="3" lg="3">
                <Label className="fw-bold">
                  {tipoDocumento?.numero_label}:
                </Label>
              </Col>
              <Col>
                <div className="d-flex align-items-center">
                  {pagamento.num_documento || "Não informado"}

                  {nomeAnexoDoc && (
                    <Button
                      name="btnDocumento"
                      color="primary"
                      className="ms-2 btn-icone-sm"
                      onClick={() => handleBotaoDocumento(nomeAnexoDoc)}
                    >
                      {ICONES_SIIG.DOCUMENTO}
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
          )}

          <Row>
            <Col sm="3" md="3" lg="3">
              <Label className="fw-bold">Forma pagamento:</Label>
            </Col>
            <Col>
              <div className="d-flex align-items-center">
                {pagamento?.forma_pagamento?.nome}

                {nomeAnexoFormaPag && (
                  <Button
                    name="btnDocumento"
                    color="secondary"
                    className="ms-2 btn-icone-sm"
                    onClick={() => handleBotaoDocumento(nomeAnexoFormaPag)}
                  >
                    {ICONES_SIIG.DOCUMENTO}
                  </Button>
                )}
              </div>
            </Col>
          </Row>

          {pagamento.conta_bancaria && (
            <Row>
              <Col sm="3" md="3" lg="3">
                <Label className="fw-bold">
                  {fn_getLabelCampoContaBancaria(
                    pagamento?.forma_pagamento?.sigla,
                  )}
                </Label>
              </Col>
              <Col>
                <div className="mb-1">
                  Banco: {pagamento.conta_bancaria?.banco?.nome}
                </div>
                <div className="mb-1">
                  Agência: {pagamento.conta_bancaria.agencia}
                </div>
                <div className="mb-2">
                  Conta: {pagamento.conta_bancaria.conta}
                </div>
              </Col>
            </Row>
          )}

          {pagamento?.forma_pagamento && pagamento?.inf_pagamento && (
            <Row>
              <Col sm="3" md="3" lg="3">
                <Label className="fw-bold">
                  {fn_getLabelCampoInfPagamento(
                    pagamento?.forma_pagamento?.sigla,
                  )}
                  :
                </Label>
              </Col>
              <Col> {pagamento?.inf_pagamento || ""}</Col>
            </Row>
          )}

          {pagamento.tipo_integracao && (
            <Row className="mt-2">
              <Col sm="3" md="3" lg="3">
                <Label className="fw-bold">Tipo integração:</Label>
              </Col>
              <Col>
                {fn_getTipoIntegracao(pagamento.tipo_integracao)?.label}
                <span className="ms-2">
                  {" "}
                  {pagamento.integracao_retirada == "S" ? "(Retirada)" : ""}
                </span>
              </Col>
            </Row>
          )}

          {
            //Usuário e data da posse só existem nas posses salvas depois que os campos foram criados
            pagamento.usuario && (
              <Row className="mt-3">
                <Col sm="3" md="3" lg="3">
                  <Label className="fw-bold">
                    Último usuário que salvou a posse:
                  </Label>
                </Col>
                <Col>
                  <div className="d-flex align-items-center">
                    <span>
                      {pagamento.usuario.nome}
                      {pagamento.data_posse && (
                        <>
                          {" "}
                          <span className="fw-bold">em</span>{" "}
                          {fn_formatarDataHora(pagamento.data_posse)}
                        </>
                      )}
                    </span>

                    {logsPosse.length > 0 && (
                      <span
                        className="ms-2 btn-icone-sm"
                        onClick={() => setModalOpenHistoricoPosse(true)}
                        title="Consultar todos os usuários que salvaram a posse"
                      >
                        {ICONES_BOTAO.VISUALIZAR}
                      </span>
                    )}
                  </div>
                </Col>
              </Row>
            )
          }

          <br />

          {logCancelamento && (
            <CardLogAutorizacao
              titulo="Cancelamento do pagamento"
              autorizacaoLog={logCancelamento}
            />
          )}

          {modalOpenHistoricoPosse && (
            <TPag_historico_posse
              modalOpen={modalOpenHistoricoPosse}
              toggleModal={() => setModalOpenHistoricoPosse(false)}
              logs={logsPosse}
            />
          )}

          {modalOpenArquivo && (
            <ModalViewArquivo
              pastaArquivo={fn_getPastaUploadSolicitacao(
                fn_getPathTenant(sessaoUsuario),
                solicitacao.numero,
              )}
              nomeArquivo={nomeArquivoView}
              solicitacao={solicitacao} //título com o tipo e o pagamento do arquivo
              isOpen={modalOpenArquivo}
              toggleModal={() => setModalOpenArquivo(!modalOpenArquivo)}
              flutuante={true}
            />
          )}
        </div>
      </ModalBody>

      <ModalFooter>
        <Button name="btnFechar" color="secondary" onClick={toggleModal}>
          {ICONES_BOTAO.FECHAR} Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default TPag_det_posse;
